exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.invalid-feedback[data-v-1a2f26b7] {\n    display: block;\n}\n", "", {"version":3,"sources":["/var/www/html/pages/_lang/purchase-preview.vue"],"names":[],"mappings":";AACA;IACI,eAAe;CAClB","file":"purchase-preview.vue","sourcesContent":["\n.invalid-feedback[data-v-1a2f26b7] {\n    display: block;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a2f26b7","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/_lang/purchase-preview.vue
// module id = ./node_modules/css-loader/index.js?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-1a2f26b7","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/_lang/purchase-preview.vue
// module chunks = 11